import { ReactNode } from "react";

// Strings (a trailing colon makes one a key), literals and numbers; whatever
// lies between matches is punctuation and whitespace.
const TOKEN =
  /("(?:\\.|[^"\\])*")(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?/g;

/**
 * Colours JSON for reading on a white background. Tolerant of input that is
 * not strictly JSON, since it is shown as Claude wrote it.
 */
const JsonCode = ({ text }: { text: string }) => {
  const nodes: ReactNode[] = [];
  let last = 0;

  for (const match of text.matchAll(TOKEN)) {
    const [token, string, colon, literal] = match;
    const index = match.index ?? 0;
    if (index > last) {
      nodes.push(
        <span key={`p${last}`} className="text-gray-500">
          {text.slice(last, index)}
        </span>
      );
    }

    if (string && colon) {
      nodes.push(
        <span key={index} className="text-sky-700">
          {string}
        </span>,
        <span key={`c${index}`} className="text-gray-500">
          {colon}
        </span>
      );
    } else {
      const className = string
        ? "text-emerald-700"
        : literal
        ? "text-purple-700"
        : "text-amber-700";
      nodes.push(
        <span key={index} className={className}>
          {token}
        </span>
      );
    }
    last = index + token.length;
  }

  if (last < text.length) {
    nodes.push(
      <span key={`p${last}`} className="text-gray-500">
        {text.slice(last)}
      </span>
    );
  }

  return <code>{nodes}</code>;
};

export default JsonCode;
